module.exports = __webpack_public_path__ + "static/img/hero-info-5.b2f0412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/zh/pc/imgs/hero-info-5.png
// module id = XJxh
// module chunks = 13